<div fullwidth>
    <nb-card
        [nbSpinner]="!all_faqs"
        nbSpinnerMessage=""
    >
        <nb-card-header>
            <div class="row">
                <div class="col-md-10 col-12">Consulta le informazioni</div>
                <div class="col-md-1 col-6"><button
                        type="button"
                        class="btn btn-danger"
                        [disabled]="!faqs_area"
                        (click)="showSearch()"
                    ><i class="fas fa-search"></i></button></div>
                <div class="col-md-1 col-6"><button
                        type="button"
                        class="btn btn-danger"
                        [disabled]="!faqs_area"
                        (click)="showGlossary()"
                    ><i class="fas fa-sort-alpha-down"></i></button></div>
            </div>


        </nb-card-header>
        <nb-card-body>In questa sezione potete trovare informazioni utili su tutto il percorso nascita, validate da
            professionisti.<br>
            Potete visualizzarle nelle tre <b>aree tematiche</b>, fare una <b>ricerca per parole chiave</b>,
            scorrere il <b>glossario</b> oppure utilizzare i <b>tag</b> relativi alle singole domande e risposte
            collegate.<br><br>
            <div>
                <gerarchia-faq
                    [macrotemi]="macrotemi"
                    [categorie]="categorie"
                    [sottocategorie]="sottocategorie"
                    [faqs]="faqs_area"
                    [parole_chiave]="parole_chiave"
                    (filtered_faqs_output)="onFaqFiltered($event)"
                ></gerarchia-faq>
            </div>
        </nb-card-body>
        <nb-card-footer>
            <div
                class="row"
                *ngIf="aree_vaste"
            >
                <div class="col-9">Seleziona un azienda sanitaria di riferimento per visualizzare anche le relative informazioni specifiche</div>
                <div class="col-3">

                    <div
                        class="dropdown ghost-dropdown"
                        ngbDropdown
                    >
                        <button
                            type="button"
                            ngbDropdownToggle
                            class="btn btn-outline-success"
                        >
                            {{ current_area?.nome || "seleziona l'area" }}
                        </button>
                        <ul
                            class="dropdown-menu"
                            ngbDropdownMenu
                        >
                            <li
                                class="dropdown-item"
                                (click)="changeArea(null)"
                            >
                                Nessun area
                            </li>
                            <li
                                class="dropdown-item"
                                *ngFor="let area of aree_vaste"
                                (click)="changeArea(area)"
                            >
                                {{ area.nome }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </nb-card-footer>
    </nb-card>
</div>
